import {
    ChartBarIcon,
    AdjustmentsHorizontalIcon,
    BuildingOfficeIcon,
    CalendarIcon,
    MapIcon,
    CurrencyDollarIcon,
    TicketIcon,
    ClipboardDocumentCheckIcon,
    TruckIcon,
    BuildingOffice2Icon,
    UserIcon,
    BanknotesIcon,
    UserGroupIcon,
    CreditCardIcon,
    ChartBarSquareIcon,
    ChartPieIcon,
} from "@heroicons/react/24/outline";
const ReportRoutes = [
    {
        path: "reports",
        exact: true,
        showChildren: true,
        sidebarMenu: true,
        displayName: "Reports",
        icon: ChartBarIcon,
        children: [
            {
                path: "company-wise-sales",
                fullPath: "reports/company-wise-sales",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Company Wise Sales",
                displayPath: "Reports > Company Wise Sales",
                icon: BuildingOfficeIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/CompanyWiseSales/index"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["reports-company-wise-sales"],
                    },
                ],
            },
            {
                path: "bdtickets-daily-bus-report",
                fullPath: "reports/bdtickets-daily-bus-report",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "bdTickets Daily Bus Report",
                displayPath: "Reports > bdTickets Daily Bus Report",
                icon: CalendarIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/BdTicketsDailyBusReport"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["reports-bdtickets-daily-bus"],
                    },
                ],
            },
            {
                path: "bdtickets-daily-air-report",
                fullPath: "reports/bdtickets-daily-air-report",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "bdTickets Daily Air Report",
                displayPath: "Reports > bdTickets Daily Air Report",
                icon: CalendarIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/BdTicketsDailyAirReport"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["reports-bdtickets-daily-air"],
                    },
                ],
            },
            {
                path: "reports-zone-wise-sales",
                fullPath: "reports/reports-zone-wise-sales",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Zone Wise Sales",
                displayPath: "Reports > Zone Wise Sales",
                icon: MapIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/CounterReports/ZoneWiseSales"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["reports-zone-wise-sales"],
                    },
                ],
            },
            {
                path: "reports-counter-prepaid-balance",
                fullPath: "reports/reports-counter-prepaid-balance",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Counter Prepaid Balance",
                displayPath: "Reports > Counter Prepaid Balance",
                icon: CurrencyDollarIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/CounterReports/CounterPrepaidBalance"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["reports-counter-prepaid-balance"],
                    },
                ],
            },
            {
                path: "reports-ticket-wise-sales",
                fullPath: "reports/reports-ticket-wise-sales",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Ticket Wise Sales",
                displayPath: "Reports > Ticket Wise Sales",
                icon: TicketIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/CounterReports/TicketWiseSales"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["reports-ticket-wise-sales"],
                    },
                ],
            },

            {
                path: "reports-daily-leaving-coach",
                fullPath: "reports/reports-daily-leaving-coach",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Daily Leaving Trip Report",
                displayPath: "Reports > Daily Leaving Trip Report",
                icon: ClipboardDocumentCheckIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/CounterReports/DailyLeavingCoach"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["reports-leaving-daily-coach"],
                    },
                ],
            },
            {
                path: "reports-coach-wise-sales",
                fullPath: "reports/reports-coach-wise-sales",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Trip Wise Sales",
                displayPath: "Reports > Trip Wise Sales",
                icon: TruckIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/CounterReports/CoachWiseSales"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["reports-coach-wise-sales"],
                    },
                ],
            },
            {
                path: "reports-new-counter-wise-sales",
                fullPath: "reports/reports-new-counter-wise-sales",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "New Counter Wise Sales",
                displayPath: "Reports > New Counter Wise Sales",
                icon: BuildingOffice2Icon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/CounterReports/NewCounterWiseSales"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["reports-new-counter-wise-sales"],
                    },
                ],
            },
            {
                path: "reports-user-wise-sales",
                fullPath: "reports/reports-user-wise-sales",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "User Wise Sales",
                displayPath: "Reports > User Wise Sales",
                icon: UserIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/CounterReports/UserWiseSales"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["reports-counter-user-wise-sales"],
                    },
                ],
            },
            {
                path: "reports-counter-wise-sales",
                fullPath: "reports/reports-counter-wise-sales",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Counter Wise Sales",
                displayPath: "Reports > Counter Wise Sales",
                icon: BanknotesIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/CounterReports/CounterWiseSales"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["reports-counter-wise-sales"],
                    },
                ],
            },
            {
                path: "reports-user-wise-sales-summary",
                fullPath: "reports/reports-user-wise-sales-summary",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "User Wise Sales Summary",
                displayPath: "Reports > User Wise Sales Summary",
                icon: UserGroupIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/CounterReports/UserWiseSalesSummary"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: [
                            "reports-counter-user-wise-sales-summary",
                        ],
                    },
                ],
            },
            {
                path: "reports-prepaid-counter-sales",
                fullPath: "reports/reports-prepaid-counter-sales",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Prepaid Counter Sales",
                displayPath: "Reports > Prepaid Counter Sales",
                icon: CreditCardIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/CounterReports/PrepaidCounterSales"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["reports-prepaid-counter-sales"],
                    },
                ],
            },
            {
                path: "reports-day-wise-sales",
                fullPath: "reports/reports-day-wise-sales",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Day Wise Sales",
                displayPath: "Reports > Day Wise Sales",
                icon: ChartBarSquareIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/CounterReports/DayWiseSales"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["reports-day-wise-sales"],
                    },
                ],
            },
            {
                path: "reports-day-wise-sales-summary",
                fullPath: "reports/reports-day-wise-sales-summary",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Day Wise Sales Summary",
                displayPath: "Reports > Day Wise Sales Summary",
                icon: ChartPieIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/CounterReports/DayWiseSalesSummary"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["reports-day-wise-sales-summary"],
                    },
                ],
            },
            {
                path: "reports-route-wise-sales",
                fullPath: "reports/reports-route-wise-sales",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Route Wise Sales",
                displayPath: "Reports > Route Wise Sales",
                icon: ChartPieIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/CounterReports/RouteWiseSales"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["reports-route-wise-sales"],
                    },
                ],
            },
            {
                path: "reports-leaving-trip-summary",
                fullPath: "reports/reports-leaving-trip-summary",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Leaving Trip Report Summary",
                displayPath: "Reports > Leaving Trip Report Summary",
                icon: ChartPieIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/CounterReports/DailyLeavingCoachSummary"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["reports-leaving-coach-summary"],
                    },
                ],
            },
            {
                path: "reports-registration-wise",
                fullPath: "reports/reports-registration-wise",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Registration No Wise Sales",
                displayPath: "Reports > Registration No Wise Sales",
                icon: ChartPieIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/CounterReports/RegistrationNoWiseSales"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["reports-registration-wise"],
                    },
                ],
            },
            {
                path: "reports-trip-wise-sales-booking",
                fullPath: "reports/reports-trip-wise-sales-booking",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Trip Wise Sales Booking",
                displayPath: "Reports > Trip Wise Sales Booking",
                icon: ChartPieIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/CounterReports/CoachWiseSalesBooking"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["reports-trip-wise-sales-booking"],
                    },
                ],
            },
            {
                path: "reports-route-fare-wise-sales",
                fullPath: "reports/reports-route-fare-wise-sales",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Route Fare Wise Sales",
                displayPath: "Reports > Route Fare Wise Sales",
                icon: ChartPieIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/CounterReports/RouteFareWiseSales"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["reports-route-fare-wise-sales"],
                    },
                ],
            },
            {
                path: "reports-sales-statement",
                fullPath: "reports/reports-sales-statement",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Daily Sales Statement Report",
                displayPath: "Reports > Daily Sales Statement Report",
                icon: ChartPieIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/CounterReports/DailySalesStatement"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["reports-sales-statement"],
                    },
                ],
            },
            {
                path: "reports-leaving-daily-coach-version-two",
                fullPath: "reports/reports-leaving-daily-coach-version-two",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Daily Leaving Trip Version Two",
                displayPath: "Reports > Daily Leaving Trip Version Two",
                icon: ChartPieIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/CounterReports/DailyLeavingCoachV2"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: [
                            "reports-leaving-daily-coach-version-two",
                        ],
                    },
                ],
            },
            {
                path: "reports-coach-wise-sales-summary",
                fullPath: "reports/reports-coach-wise-sales-summary",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Trip Wise Sales Summary",
                displayPath: "Reports > Trip Wise Sales Summary",
                icon: ChartPieIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/CounterReports/CoachWiseSalesSummary"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["reports-coach-wise-sales-summary"],
                    },
                ],
            },
            {
                path: "reports-all-sms",
                fullPath: "reports/reports-all-sms",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "All SMS Report",
                displayPath: "Reports > All SMS Report",
                icon: ChartPieIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/CounterReports/AllSmsReport"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["reports-all-sms"],
                    },
                ],
            },
            {
                path: "reports-all-counter-user-wise-sales",
                fullPath: "reports/reports-all-counter-user-wise-sales",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "All Counter User Wise Sales",
                displayPath: "Reports > All Counter User Wise Sales",
                icon: ChartPieIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/CounterReports/AllCounterUserWiseSales"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["reports-all-counter-user-wise-sales"],
                    },
                ],
            },
            {
                path: "reports-desh-india",
                fullPath: "reports/reports-desh-india",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Desh India Report",
                displayPath: "Reports > Desh India Report",
                icon: ChartPieIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Reports/CounterReports/DeshIndia"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["reports-desh-india"],
                    },
                ],
            },
        ],
    },
];

export default ReportRoutes;
